import { render, staticRenderFns } from "./PhysicalAssessmentEffect.vue?vue&type=template&id=5e33f354&scoped=true&"
import script from "./PhysicalAssessmentEffect.vue?vue&type=script&lang=js&"
export * from "./PhysicalAssessmentEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e33f354",
  null
  
)

export default component.exports